import { TitleButton } from '@/common/buttons/TitleButton';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useTheme } from '@mui/material';
import { useState } from 'react';
import { CtrtOutline } from './CtrtOutline';

/**
 * Shares the Contract outline toggle across the Contract and everything under it. On a child the
 * outline opens collapsed apart from the branch leading to that child.
 */
export const useCtrtOutline = ({ ctrtId, entity, entityId }) => {
  const theme = useTheme();

  const [outline, setOutline] = useState(false);

  const augButtons = (buttons) => {
    if (!ctrtId) return;

    buttons.push(
      <TitleButton
        key="outlineToggleButton"
        icon={fas.faSitemap}
        color={outline ? theme.palette.primary.main : undefined}
        toolTip={outline ? 'Show details' : 'Show contract outline'}
        onClick={() => setOutline(!outline)}
      />,
    );
  };

  const outlineContent =
    outline && ctrtId ? <CtrtOutline ctrtId={ctrtId} focusEntity={entity} focusEntityId={entityId} /> : undefined;

  return { augButtons, outlineContent };
};
